export default __webpack_public_path__ + "static/media/logoMMR-EN.542aa791.svg";